import React from 'react';
import cn from 'classnames';
import styles from './styles.scss';
import ReactModal from 'react-modal';
import iconCloseDefault from 'assets/images/icons/cross.svg';

const scrollOn = () => {
  document.body.classList.remove('scroll-off');
};

const scrollOff = () => {
  document.body.classList.add('scroll-off');
};

const Modal = ({
  classNames: { titleClassName, bodyClassName, closeClassName } = {},
  footer = null,
  isOpen, handleClose, title, children, contentStyle = {}, overlayStyle = {} }) => {
  const onClose = () => {
    scrollOn();
    handleClose();
  };

  return (<ReactModal
    isOpen={isOpen}
    onAfterOpen={scrollOff}
    onRequestClose={onClose}
    contentLabel="Modal"
    className={styles.ModalContent}
    style={{
      overlay: {
        zIndex: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        ...overlayStyle
      },
      content: {
        padding: 0,
        background: '#fff',
        border: 'none',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        WebkitTransform: 'translate(-50%, -50%)',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        ...contentStyle
      }
    }}
  >

    {
      title &&
      <div
        className={cn(styles.Title, {
          [titleClassName]: !!titleClassName
        })}
      >
        { title }
      </div>
    }
    <div
      className={cn(styles.Close, {
        [closeClassName]: !!closeClassName
      })}
      onClick={onClose}
    >
      <img src={iconCloseDefault} alt="" />
    </div>
    <div
      className={cn(styles.Content, {
        [bodyClassName]: !!bodyClassName
      })}
    >
      {
        children
      }
    </div>
    {footer && (
      <div className={styles.Footer}>
        {footer}
      </div>
    )}
  </ReactModal>);
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js